<template>

    <button type="button" class="btn" :class="['btn--' + variant, 'btn--' + size]" :disabled="disabled">
        <AppIcon v-if="icon" :name="icon" class="btn-icon"/>
        <span>{{ title }}</span>
    </button>

</template>


<script>

import AppIcon from './AppIcon.vue';

export default {
    name: 'ButtonUI',

    components: {
        AppIcon
    },

    props: {
        title: {
            type: String,
            default: 'Кнопка'
        },
        icon: {
            type: String,
        },
        variant: {
            type: String,
            default: 'default'
        },
        size: {
            type: String,
            default: 'default'
        },
        disabled: {
            type: Boolean,
            default: false
        },
    }
}

</script>


<style scoped>

.btn{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    height: 38px;
    padding: 0 16px;

    border: 1px solid transparent;
    border-radius: 8px;

    font-family: inherit;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    white-space: nowrap;

    cursor: pointer;

    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.btn:focus-visible{
    outline: none;
    box-shadow: 0 0 0 3px var(--ring);
}

.btn:disabled{
    opacity: 0.5;
    cursor: not-allowed;
}

.btn--default{
    background: var(--primary);
    color: var(--primary-foreground);
}

.btn--default:hover{
    background: var(--primary-hover);
}

.btn--outline{
    background: var(--card);
    border-color: var(--border);
    color: var(--foreground);
}

.btn--outline:hover{
    background: var(--muted);
}

.btn--ghost{
    background: transparent;
    color: var(--foreground);
}

.btn--ghost:hover{
    background: var(--muted);
}

.btn--destructive{
    background: var(--destructive);
    color: #ffffff;
}

.btn--destructive:hover{
    background: var(--destructive-hover);
}

.btn--sm{
    height: 32px;
    padding: 0 12px;
    font-size: 13px;
}

.btn-icon{
    width: 15px;
    height: 15px;
    opacity: 0.9;
}

</style>

